import React, { useState } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import { Context } from "../../../../_context/Store";
import Validator from "../../../../_helpers/validate.schema";

import {
    UiCol,
    UiSingleRow,
} from "../../../_uiComponents/grid-container/GridContainer";

import { UiInput } from "../../../_uiComponents/form/UiInput";
import { UiButtonPrimary } from "../../../_uiComponents/form/UiButton";
import ValidateRightDark from "../../../../styles/img/svg/ValidateRightDark";
import ValidateRightLight from "../../../../styles/img/svg/ValidateRightLight";
import {
    forgotPasswordEmailVeryficationRequest,
    forgotPasswordResetPasswordRequest,
} from "../../../../_redux/_actions";
import { getFingerPrint } from "../../../../_helpers/support.services";

const validateSchema = () =>
    yup.object().shape({
        newPassword: yup
            .string()
            .min(8, "New password must be at least 8 characters long.")
            .matches(
                /[^\w\s]/,
                "New password must contain at least one special character.",
            )
            .matches(
                /[A-Z]/,
                "New password must contain at least one uppercase letter.",
            )
            .matches(
                /[a-z]/,
                "New password must contain at least one lowercase letter.",
            )
            .matches(/[0-9]/, "New password must contain at least one number.")
            .required("New password is required."),
        confirmPassword: yup
            .string()
            .oneOf(
                [yup.ref("newPassword")],
                "Confirm password should be equal to new password.",
            )
            .required("Confirm password is required."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function ResetPassword(props) {
    

    const actionDispatch = useDispatch();

    const navigate = useNavigate();

    const [payload, setPayload] = useState({});
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get("user_id");
    const authToken = urlParams.get("auth_token");
    const resetType = urlParams.get("type");

    const haMinimumEightCharacters = newPassword.length >= 8;
    const hasSpecialCharacters = /[^\w\s]/.test(newPassword);
    const hasUpperCaseCharacters = newPassword && /[A-Z]/.test(newPassword);
    const hasLowerCaseCharacters = newPassword && /[a-z]/.test(newPassword);
    const hasNumericCaseCharacters = newPassword && /[0-9]/.test(newPassword);

    const submit = async (values, form) => {

        const browserFingerprint = await getFingerPrint();

        actionDispatch(
            forgotPasswordResetPasswordRequest({
                ...values,
                authToken,
                userId,
                form,
                validateOtp: false,
                browserFingerprint,
                navigate
            }),
        );
    };
    return (
        <>
            <Form
                onSubmit={submit}
                validate={onValidate}
                render={({
                    handleSubmit,
                    hasValidationErrors,
                    valid,
                    ...rest
                }) => {
                    return (
                        <form onSubmit={validateSchema}>
                            <UiInput
                                placeholder="New Password"
                                type="password"
                                inputhideicon={true}
                                name="newPassword"
                                onChange={(e) => {
                                    setNewPassword(e.target.value);
                                }}
                            />
                            <div className="sb-password-restrictions">
                                <ul>
                                    <li>
                                        {haMinimumEightCharacters ? (
                                            <ValidateRightDark />
                                        ) : (
                                            <ValidateRightLight />
                                        )}{" "}
                                        Minimum 8 Characters
                                    </li>
                                    <li>
                                        {hasSpecialCharacters ? (
                                            <ValidateRightDark />
                                        ) : (
                                            <ValidateRightLight />
                                        )}{" "}
                                        Special Characters
                                    </li>
                                    <li>
                                        {hasUpperCaseCharacters ? (
                                            <ValidateRightDark />
                                        ) : (
                                            <ValidateRightLight />
                                        )}{" "}
                                        Uppercase Characters
                                    </li>
                                    <li>
                                        {hasLowerCaseCharacters ? (
                                            <ValidateRightDark />
                                        ) : (
                                            <ValidateRightLight />
                                        )}{" "}
                                        Lowercase Characters
                                    </li>
                                    <li>
                                        {hasNumericCaseCharacters ? (
                                            <ValidateRightDark />
                                        ) : (
                                            <ValidateRightLight />
                                        )}{" "}
                                        Numeric Characters
                                    </li>
                                </ul>
                            </div>
                            <UiInput
                                placeholder="Confirm New Password"
                                type="password"
                                inputhideicon={true}
                                name="confirmPassword"
                            />
                            <UiSingleRow>
                                <UiCol lg="12">
                                    <div className="sb-auth-top-wr__btns sb-auth-reset-pwd-btns">
                                        <div className="sb-auth-top-wr__btns-cancel">
                                            <UiButtonPrimary
                                                btnName="Cancel"
                                                onClick={()=>navigate("/")}
                                            />
                                        </div>
                                        <div className="sb-auth-top-wr__btns-verify">
                                            <UiButtonPrimary
                                                btnName="Verify"
                                                onClick={handleSubmit}
                                            />
                                        </div>
                                    </div>
                                </UiCol>
                            </UiSingleRow>
                        </form>
                    );
                }}
            />
        </>
    );
}
